module.exports = __webpack_public_path__ + "static/media/48359615_2309076445834200_1357674432537034752_o-thumb.6303a3a0.jpg";